module.exports = __webpack_public_path__ + "static/media/016.5d5656cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/016.jpg
// module id = 313
// module chunks = 0